export const UNLINK_ERROR = "unlink error";

export const CONSENT_ERROR = "sso-consent-denied";

export const EMAIL_UNAVAILABLE = "sso-email-in-use";

export const EMAIL_NOT_SHARED = "sso-data-denied";
